import { OpenThermVariableName } from 'openTherm';
import { AnalogInput, BoilerAdapter, HeatingCircuit, } from 'z3k-config';
import { prettyFloat } from 'webui/utils/number';
import { ThermometerState } from 'webui/utils/thermometers';
export const getOtParamsSensorState = (OT_sensors, ot_state, status_boiler_adapter) => {
    return OT_sensors.map((elem) => {
        const max_modulation = ot_state?.[OpenThermVariableName.mrml] ?? 100;
        const sensor_type = elem.ot_name === OpenThermVariableName.rml
            ? AnalogInput.Type.HUMIDITY_SENSOR
            : AnalogInput.Type.PRESSURE_SENSOR_5;
        const unit = AnalogInput.getUnit({
            sensor_type,
        });
        const limits = {
            high: elem?.ot_name == OpenThermVariableName.rml
                ? max_modulation
                : elem?.ot_name == OpenThermVariableName.fr
                    ? 35
                    : 3,
            low: elem?.lower_threshold !== undefined ? elem.lower_threshold : null,
        };
        const value = elem
            ? Number(prettyFloat(ot_state?.[elem.ot_name], 1))
            : null;
        const alarm = status_boiler_adapter.no_valid_params;
        const no_connection = status_boiler_adapter.no_adapter_connection ||
            status_boiler_adapter.no_boiler_connection;
        return {
            boiler_adapter_id: elem.id,
            ot_name: elem.ot_name,
            name: elem.name,
            limits,
            value,
            unit: elem.ot_name === OpenThermVariableName.fr ? 'л/мин' : unit,
            alarm,
            no_connection,
        };
    });
};
export const select_boiler_adapter_limits = (config, sensor) => {
    const heating_circuit = HeatingCircuit.get.one(config, ({ control_devices, type }) => HeatingCircuit.isBoiler({ type }) && control_devices.includes(sensor.id));
    const limits_default = { min: -40, max: 40 };
    const low = heating_circuit?.water_min_temperature
        ? Number(heating_circuit?.water_min_temperature)
        : sensor.lower_threshold != null
            ? sensor.lower_threshold
            : limits_default.min;
    const high = heating_circuit?.water_max_temperature
        ? Number(heating_circuit?.water_max_temperature)
        : sensor.upper_threshold != null
            ? sensor.upper_threshold
            : limits_default.max;
    return {
        heating_circuit_id: heating_circuit?.id,
        limits: { low, high },
    };
};
const getStateSensors = (boiler_adapter_id, z3k_config, ot_state) => {
    if (boiler_adapter_id) {
        const parent_boiler_adapter = BoilerAdapter.get.byId(z3k_config, boiler_adapter_id);
        const boiler_adapter_error = parent_boiler_adapter
            ? BoilerAdapter.hasOTError(parent_boiler_adapter, ot_state)
            : false;
        return boiler_adapter_error
            ? ThermometerState.malfunction
            : ThermometerState.ok;
    }
    return ThermometerState.disconnected;
};
export const getOtTemperatureSensorState = (OT_temperatur_sensors, ot_state, z3k_config) => {
    return OT_temperatur_sensors.map((thermometer) => {
        const { id: boiler_adapter_id, ot_name, name: sensor_name } = thermometer;
        const { heating_circuit_id, limits } = select_boiler_adapter_limits(z3k_config, thermometer);
        const parent_boiler_adapter = BoilerAdapter.get.byId(z3k_config, boiler_adapter_id);
        const name = `${parent_boiler_adapter?.name ?? ''} ${sensor_name} ЦШ`;
        const boiler_adapter_temperature = ot_state?.[ot_name] ?? undefined;
        const boiler_adapter_state = getStateSensors(boiler_adapter_id, z3k_config, ot_state);
        return {
            boiler_adapter_id,
            ot_name,
            name: name,
            heating_circuit_id,
            limits,
            unit: '°',
            value: boiler_adapter_temperature,
            state: boiler_adapter_state,
        };
    });
};
